import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://a3861cf5fdad35d2b21c2bddaf98a317@o245540.ingest.us.sentry.io/4508086424829952",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});